import React from "react"
import { defineMessages, injectIntl } from "react-intl"
import { Intl } from "../../state/helpers/IntlProps"
import IntegrationConfigurationValue from "../../state/integration/IntegrationConfigurationValue"

const messages = defineMessages({
    "choose_option": {
        id: "integration.form.edit.choose_option",
        defaultMessage: "Choose",
    },
})

type OwnProps = {
    value: string,
    configurationValue: IntegrationConfigurationValue,
    onChange: (newValue: string) => void,
    renderConfigurationValueLabel: (configurationValueKey: string) => JSX.Element,
    intl: Intl,
    valuesDescription?: object,
    hideDefaultOption?: boolean,
}

const ConfigurationValueComponent = (props: OwnProps) => {

    const options = [] as JSX.Element[]
    const keys = Object.keys(props?.configurationValue?.getValues() ?? {})
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        const value = props.configurationValue.getValues()[key]

        //have the empty key as the first option if it's the last key-value
        if (i === keys.length - 1 && key === "") {
            options.unshift(<option value={key} key={i}>
                {value}
            </option>)
        } else {
            options.push(<option value={key} key={i}>
                {value}
            </option>)
        }
    }
    return <div className="form-group row" key={props.configurationValue.getId()}>
        <label className="col-3 col-form-label text-align-right" htmlFor={props.configurationValue.getId()}>
            {props.renderConfigurationValueLabel(props.configurationValue.getKey())}
        </label>
        <div className="col-9">
            <select
                name={props.configurationValue.getId()}
                value={props.value}
                onChange={e => {
                    props.onChange(e.target.value)
                }}
                id={props.configurationValue.getId()}
                className="form-control"
            >
                {!props.hideDefaultOption &&
                    <option value={""}>{props.intl.formatMessage(messages["choose_option"])}</option>
                }
                {options}
            </select>
            {props.valuesDescription && props.valuesDescription[props.value] &&
                <small className="form-text text-muted">
                    {props.valuesDescription[props.value]}
                </small>
            }
        </div>
    </div>

}

export default injectIntl(ConfigurationValueComponent)


// WEBPACK FOOTER //
// ./src/integration/form/ConfigurationValueComponent.tsx